<div class="historical-stores-page-container container">
  <p>{{ 'historicalStores.foundData' | translate }}</p>
  <mtn-other-stores-table [otherStores]="otherStores" *ngIf="otherStores?.length"
                          (linkClick)="close()"></mtn-other-stores-table>
</div>
